export default class InboundRedeemableResponse {

    constructor(jsonResponse) {
        this.transactionId = jsonResponse["transaction-id"];
        this.redeemable = jsonResponse["redeemable"];
        this.message = jsonResponse["message"];
    }
}